export const keepAliceWriteRouters = ['contract', 'enterprise', 'enpAccount',
  'account', 'car', 'carLearningReport', 'accountRecord', 'accountReport',
  'msg', 'preRecord', 'preRecordDetail', 'preRecordDetailReport', 'curriculum',
  'curriculumCustomCourse', 'curriculumReleaseDetail', 'policy', 'courseware',
  'course', 'courseReleaseDetail', 'bindCourseware', 'questionBank',
  'testQuestions', 'offline', 'plan', 'examineReport', 'customCourse',
  'planReleaseDetail', 'report', 'train', 'trainIncomplete', 'trainCompleted', 'trainInReport', 'trainHistory',
  'open', 'processReview', 'setProcess']
